module.exports = function($){
  $.FW   = false;
  $.path = $.core;
  return $;
};


/*****************
 ** WEBPACK FOOTER
 ** /code/~/core-js/library/modules/$.fw.js
 ** module id = 819
 ** module chunks = 0
 **/